<template>
  <div>
    <el-form size="mini" style="margin-bottom: 5px;">
      <el-button type="primary" size="mini" @click="ue_add" icon="el-icon-plus">增加</el-button>
    </el-form>
    <el-table :data="cmpData" stripe border size="mini">
      <el-table-column label="编码" prop="id" width="60"></el-table-column>
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" @click="ue_Edit(scope.row)" size="mini" type="text" title="编辑">编辑</el-button>
        </template>
      </el-table-column>
      <el-table-column label="名称" prop="name" show-overflow-tooltip width="200"></el-table-column>
      <el-table-column label="描述" prop="memo" show-overflow-tooltip></el-table-column>
    </el-table>
    <el-dialog title="公司信息维护"
               class="d-dialog"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               :visible.sync="showEdit"
               width="550px">

      <el-form label-width="80px"
               size="mini"
               ref="Edit"
               :rules="rules"
               :model="Edit">
        <el-form-item label="编号">
          <el-input v-model="Edit.id" :disabled="true" placeholder="自动生成"></el-input>
        </el-form-item>
        <el-form-item label="公司名称" prop="name">
          <el-input v-model="Edit.name" placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="Edit.memo" rows="5" type="textarea" maxlength="255" show-word-limit
                    placeholder="请输入公司名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="showEdit = false">关闭</el-button>
        <el-button size="mini" type="primary" @click.native="ue_save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import * as Api from '../api/api'

  export default {
    data() {
      return {
        cmpData: [],
        Edit: {},
        rules: {
          name: [
            {required: true, message: '公司名称不能为空', trigger: 'blur'}
          ]
        },
        showEdit: false
      }
    },
    mounted() {
      this.f_loadData();
    },
    methods: {
      ue_add() {
        this.f_clear();
        this.showEdit = true;
      },
      ue_Edit(row) {
        this.Edit = {};
        this.Edit = JSON.parse(JSON.stringify(row));
        this.showEdit = true;
      },
      ue_save() {
        this.$refs.Edit.validate((valid) => {
          if (valid) {
            let parm = JSON.parse(JSON.stringify(this.Edit));
            Api.AddCompany(parm).then(res => {
              if (res.code === 1) {
                this.$message.success("保存成功");
                this.showEdit = false;
                this.f_loadData();
              }
            });
          }
        });
      },

      f_loadData() {
        Api.GetCompany({}).then(res => {
          this.cmpData = res.data;
        });
      },
      f_clear() {
        this.Edit = {};
        this.Edit = {
          name: "",
          memo: ""
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Company.vue